/* INVELO: display language and currency on the landing page.
   Geo by IP (not by browser language). Checkout on the White stores via country=. */
(function (w) {
  var LATAM = {
    MX: { lang: 'es', currency: 'MXN', locale: 'en-US', symbol: '$', decimals: 2, name: 'Mexico' },
    AR: { lang: 'es', currency: 'ARS', locale: 'en-US', symbol: '$', decimals: 0, name: 'Argentina' },
    CO: { lang: 'es', currency: 'COP', locale: 'en-US', symbol: '$', decimals: 0, name: 'Colombia' },
    CL: { lang: 'es', currency: 'CLP', locale: 'en-US', symbol: '$', decimals: 0, name: 'Chile' },
    PE: { lang: 'es', currency: 'PEN', locale: 'en-US', symbol: 'S/', decimals: 2, name: 'Peru' },
    GT: { lang: 'es', currency: 'GTQ', locale: 'en-US', symbol: 'Q', decimals: 2, name: 'Guatemala' },
    CR: { lang: 'es', currency: 'CRC', locale: 'en-US', symbol: '₡', decimals: 0, name: 'Costa Rica' },
    PA: { lang: 'es', currency: 'USD', locale: 'en-US', symbol: 'US$', decimals: 2, name: 'Panama' },
    EC: { lang: 'es', currency: 'USD', locale: 'en-US', symbol: 'US$', decimals: 2, name: 'Ecuador' },
    UY: { lang: 'es', currency: 'UYU', locale: 'en-US', symbol: '$', decimals: 0, name: 'Uruguay' },
    BO: { lang: 'es', currency: 'BOB', locale: 'en-US', symbol: 'Bs', decimals: 2, name: 'Bolivia' },
    PY: { lang: 'es', currency: 'PYG', locale: 'en-US', symbol: '₲', decimals: 0, name: 'Paraguay' },
    DO: { lang: 'es', currency: 'DOP', locale: 'en-US', symbol: 'RD$', decimals: 0, name: 'Dominican Republic' },
    SV: { lang: 'es', currency: 'USD', locale: 'en-US', symbol: 'US$', decimals: 2, name: 'El Salvador' },
    HN: { lang: 'es', currency: 'HNL', locale: 'en-US', symbol: 'L', decimals: 2, name: 'Honduras' },
    NI: { lang: 'es', currency: 'NIO', locale: 'en-US', symbol: 'C$', decimals: 2, name: 'Nicaragua' },
    ES: { lang: 'es', currency: 'EUR', locale: 'en-US', symbol: '€', decimals: 2, name: 'Spain' }
  };
  var PT = { lang: 'pt', currency: 'EUR', locale: 'en-US', symbol: '€', decimals: 2, name: 'Portugal', country: 'PT' };
  var RATES = { EUR: 1, USD: 1.08, MXN: 21.4, COP: 4300, CLP: 1060, ARS: 1400, PEN: 4.05, GTQ: 8.4, CRC: 545, UYU: 46, BOB: 7.5, PYG: 8500, DOP: 64, HNL: 27, NIO: 39.5 };
  var ZERO_DEC = { CLP: 1, COP: 1, PYG: 1, JPY: 1, KRW: 1, VND: 1 };
  var SHOP_PRICES = null;
  var PRICES_URL = 'https://app.edelkoffer.de/api/market-prices.php';

  var I18N = {
    pt: {
      'available': 'Available for {model}',
      'availableSub': 'Made to measure · {brand}',
      'config.brand': 'Make',
      'config.model': 'Model',
      'config.year': 'Year',
      'kit.title': 'Choose the right protection',
      'kit.f3': 'Premium trunk mat',
      'kit.pickupTitle': 'Pickup truck kits',
      'kit.f3pickup': 'Premium truck bed mat'
    },
    es: {
      'nav.home': 'Home',
      'nav.benefits': 'Benefits',
      'nav.config': 'Configure Your Vehicle',
      'nav.compare': 'Comparison',
      'nav.reviews': 'Reviews',
      'nav.details': 'Details',
      'hero.kicker': 'Premium 3D Car Mats',
      'hero.title': 'Protect<br>Your Interior.',
      'hero.desc': 'Custom-fit for your vehicle. Full protection against dirt, spills, and wear.',
      'hero.rating': '<strong>4.9</strong> · 98% satisfaction',
      'hero.cta': 'CUSTOMIZE MY KIT',
      'ben.t1': 'Total Protection',
      'ben.d1': 'Against dirt, spills, and wear.',
      'ben.t2': 'Perfect Fit',
      'ben.d2': 'Custom-fit for 500+ models.',
      'ben.t3': '100% Waterproof',
      'ben.d3': 'Raised edge that traps spills.',
      'ben.t4': '3-Year Warranty',
      'ben.d4': 'Against manufacturing defects.',
      'config.label': 'Custom fit',
      'config.title': 'Configure your vehicle',
      'config.desc': 'Select the make, model, and year to see the exclusive price for your vehicle.',
      'config.id': 'Vehicle details',
      'config.brand': 'Make',
      'config.model': 'Model',
      'config.year': 'Year',
      'config.notfound': 'I can’t find my vehicle',
      'config.loading': 'Checking availability...',
      'kit.label': 'Choose your kit',
      'kit.title': 'Choose the right protection',
      'kit.pickupTitle': 'Pickup truck kits',
      'kit.basic': 'Basic Kit',
      'kit.full': 'Complete Kit',
      'kit.best': 'Best seller',
      'kit.f1': '3 custom-fit interior mats',
      'kit.f2': 'One-piece rear mat with center coverage',
      'kit.f3': 'Premium trunk mat',
      'kit.f3pickup': 'Premium truck bed mat',
      'kit.f4': 'BONUS: Free air freshener',
      'total.label': 'Kit total',
      'total.ship': 'FREE SHIPPING',
      'total.pay': 'Secure payment',
      'buy': 'BUY NOW',
      'trust.safe': 'Secure checkout',
      'trust.warr': '3-year warranty',
      'trust.fit': 'Custom fit',
      'price.from': 'STARTING AT',
      'price.note': 'Select your vehicle above to see your price',
      'tag.ship': 'Free shipping',
      'tag.warr': '3-year warranty',
      'available': 'Available for {model}',
      'availableSub': 'Made to measure · {brand}',
      'menu.open': 'Open menu',
      'menu.close': 'Close menu',
      'sticky.cta': 'SELECT YOUR VEHICLE',
      'sticky.total': 'Total',
      'cmp.title': 'See the difference',
      'cmp.sub': 'Real protection, every day',
      'cmp.before': 'BEFORE',
      'cmp.after': 'AFTER',
      'tbl.title': 'INVELO vs. Standard Mats',
      'tbl.feat': 'FEATURE',
      'tbl.common': 'STANDARD',
      'tbl.r1': 'Custom-fit for your vehicle',
      'tbl.r2': 'Raised 5 cm edges',
      'tbl.r3': '100% waterproof',
      'tbl.r4': 'Factory anchor-compatible grommets',
      'tbl.r5': 'Premium 7 mm rubber',
      'tbl.r6': '3-year warranty',
      'sat.title': 'Satisfaction Guaranteed',
      'sat.sub': 'More than 10,371 vehicles protected across Europe',
      'rev.rating': '<strong>4.9</strong> · 98% satisfaction',
      'rev.title': 'What our customers say',
      'rev.sub': 'Real reviews with customer photos of the installed product',
      'rev.photo': 'Real customer photo',
      'rev.product': 'Premium Trunk Mat',
      'rev.verified': 'Verified purchase',
      'stat.models': 'Compatible models',
      'stat.waterproof': 'Waterproof',
      'stat.warranty': 'Months of warranty',
      'det.title': 'Details that make the difference',
      'det.h1': 'High-Performance Premium Rubber',
      'det.p1': '7 mm material with extreme wear resistance. 100% waterproof, it holds up through years of heavy use.',
      'det.h2': 'Factory-Fit Anchor Grommets',
      'det.p2': 'Metal grommets that fit your vehicle’s anchor points. Total stability, no sliding.',
      'det.h3': 'Raised Containment Edges',
      'det.p3': '5 cm edges that hold in spills, mud, and debris. Complete protection for your factory carpet.',
      'faq.q1': 'Product Description',
      'faq.a1': 'Premium car mats made from high-performance rubber, custom-designed for each vehicle model. Perfect fit, total protection, and a superior finish.',
      'faq.q2': 'Shipping',
      'faq.a2a': 'Free shipping nationwide (see the delivery times for your country at checkout).',
      'faq.a2b': 'Average delivery time: 5 to 10 business days.',
      'faq.a2c': 'Each product is made to measure after your order is confirmed.',
      'faq.q3': 'Warranty and Returns',
      'faq.a3a': '3-year legal warranty against defects and nonconformity.',
      'faq.a3b': 'Returns or exchanges within 30 days, at no cost to you.',
      'faq.q4': 'Technical Specifications',
      'faq.spec.mat': 'Material',
      'faq.spec.matv': 'Premium high-strength rubber',
      'faq.spec.th': 'Thickness',
      'faq.spec.edge': 'Raised edge',
      'faq.spec.base': 'Base',
      'faq.spec.basev': 'Non-slip system',
      'faq.spec.imp': 'Waterproof',
      'faq.spec.uv': 'UV protection',
      'faq.spec.yes': 'Yes',
      'ft.blurb': 'INVELO specializes in premium custom-fit car accessories. Quality, comfort, and protection for your vehicle.',
      'ft.info': 'Information',
      'ft.privacy': 'Privacy Policy',
      'ft.cookies': 'Cookie Policy',
      'ft.terms': 'Terms and Conditions',
      'ft.ship': 'Shipping and Delivery Policy',
      'ft.returns': 'Exchanges and Returns Policy',
      'ft.legal': 'Legal Notice',
      'ft.complaints': 'Complaints Book',
      'ft.contact': 'Contact',
      'ft.copy': '© 2026 INVELO · invelocar.shop · All rights reserved'
    }
  };

  function valid(code) {
    return code === 'PT' || !!(code && LATAM[code]);
  }

  function param() {
    try {
      var p = new URLSearchParams(w.location.search);
      return (p.get('gl') || p.get('country') || p.get('market') || '').toUpperCase();
    } catch (e) { return ''; }
  }

  function fromLang() {
    var l = (navigator.language || navigator.userLanguage || '').toLowerCase();
    var region = (l.split('-')[1] || '').toUpperCase();
    if (l.indexOf('es') === 0) {
      if (region && LATAM[region] && region !== 'ES') return region;
      return '';
    }
    if (l.indexOf('pt') === 0) return 'PT';
    return '';
  }

  function parseTrace(txt) {
    var m = String(txt || '').match(/(?:^|\n)loc=([A-Z]{2})/i);
    return m ? m[1].toUpperCase() : '';
  }

  function marketFor(code) {
    if (code === 'PT' || !LATAM[code]) return Object.assign({ country: 'PT' }, PT);
    return Object.assign({ country: code }, LATAM[code]);
  }

  function paintMoney(amount, currency, locale, symbol) {
    var cur = currency || 'EUR';
    var dec = ZERO_DEC[cur] ? 0 : 2;
    var n = Number(amount);
    if (!isFinite(n)) n = 0;
    if (dec === 0) n = Math.round(n);
    else n = Math.round(n * 100) / 100;
    var formatted;
    try {
      formatted = new Intl.NumberFormat(locale || 'en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(n);
    } catch (e) {
      formatted = dec ? n.toFixed(dec) : String(Math.round(n));
    }
    if (cur === 'EUR') return '€' + formatted;
    var sym = symbol || (w.INVELO_MARKET && w.INVELO_MARKET.symbol) || '';
    if (sym === 'S/' || sym === 'Q' || sym === 'Bs') return sym + ' ' + formatted;
    if (sym === '$' || cur === 'MXN' || cur === 'ARS' || cur === 'COP' || cur === 'CLP' || cur === 'USD') {
      return (sym || '$') + formatted + (cur !== 'USD' ? ' ' + cur : '');
    }
    return (sym ? sym : '') + formatted + (sym ? '' : ' ' + cur);
  }

  function formatMoney(eur, kit) {
    var m = w.INVELO_MARKET || PT;
    if (SHOP_PRICES && kit) {
      var row = kit.indexOf('Compare') >= 0
        ? SHOP_PRICES[kit.replace('Compare', '')]
        : SHOP_PRICES[kit];
      if (row) {
        var amt = kit.indexOf('Compare') >= 0 ? row.compare : row.amount;
        if (amt != null) return paintMoney(amt, SHOP_PRICES.currency, m.locale, m.symbol);
      }
    }
    var rate = RATES[m.currency] || 1;
    return paintMoney(Number(eur) * rate, m.currency, m.locale, m.symbol);
  }

  function fetchShopPrices(code, cb) {
    var url = PRICES_URL + '?country=' + encodeURIComponent(code);
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && (d.basico || d.completo)) {
          SHOP_PRICES = d;
          if (d.currency) {
            w.INVELO_MARKET = Object.assign({}, w.INVELO_MARKET || {}, { currency: d.currency });
          }
        }
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  function setText(el, lang, key, attrPt, useHtml) {
    var dict = I18N[lang] || {};
    if (lang === 'pt') {
      var orig = el.getAttribute(attrPt);
      if (orig != null) {
        if (useHtml) el.innerHTML = orig; else el.textContent = orig;
      }
      return;
    }
    if (!el.getAttribute(attrPt)) el.setAttribute(attrPt, useHtml ? el.innerHTML : (el.textContent || ''));
    if (dict[key]) {
      if (useHtml) el.innerHTML = dict[key]; else el.textContent = dict[key];
    }
  }

  function applyI18n(lang) {
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      if (key) setText(el, lang, key, 'data-i18n-pt', true);
    });
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-placeholder');
      var dict = I18N[lang] || {};
      if (lang === 'pt') {
        if (el.getAttribute('data-ph-pt')) el.textContent = el.getAttribute('data-ph-pt');
        return;
      }
      if (!el.getAttribute('data-ph-pt')) el.setAttribute('data-ph-pt', el.textContent || '');
      if (dict[key]) el.textContent = dict[key];
    });
    document.querySelectorAll('[data-i18n-aria]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-aria');
      var dict = I18N[lang] || {};
      if (lang === 'pt') {
        if (el.getAttribute('data-aria-pt')) el.setAttribute('aria-label', el.getAttribute('data-aria-pt'));
        return;
      }
      if (!el.getAttribute('data-aria-pt')) el.setAttribute('data-aria-pt', el.getAttribute('aria-label') || '');
      if (dict[key]) el.setAttribute('aria-label', dict[key]);
    });
    document.documentElement.lang = 'en';
    document.documentElement.setAttribute('data-invelo-market', (w.INVELO_MARKET && w.INVELO_MARKET.country) || 'PT');
  }

  function debugChip() {
    try {
      var p = new URLSearchParams(w.location.search);
      if (p.get('invelo_debug') !== '1' && p.get('debug') !== 'geo') return;
    } catch (e) { return; }
    var m = w.INVELO_MARKET || PT;
    var el = document.getElementById('invelo-geo-debug');
    if (!el) {
      el = document.createElement('div');
      el.id = 'invelo-geo-debug';
      el.style.cssText = 'position:fixed;z-index:99999;left:8px;bottom:8px;background:#111;color:#c9a96e;font:12px/1.3 sans-serif;padding:8px 10px;border-radius:8px;border:1px solid #c9a96e;';
      (document.body || document.documentElement).appendChild(el);
    }
    el.textContent = m.country + ' · ' + m.lang + ' · ' + m.currency;
  }

  function persist(code) {
    if (!valid(code)) code = 'PT';
    try { localStorage.setItem('invelo_gl', code); } catch (e) {}
    w.INVELO_MARKET = marketFor(code);
    applyI18n(w.INVELO_MARKET.lang);
    document.dispatchEvent(new CustomEvent('invelo:market', { detail: w.INVELO_MARKET }));
    debugChip();
    fetchShopPrices(code, function () {
      applyI18n(w.INVELO_MARKET.lang);
      if (typeof w.updateKitUI === 'function') try { w.updateKitUI(); } catch (e) {}
      document.dispatchEvent(new CustomEvent('invelo:market', { detail: w.INVELO_MARKET }));
      debugChip();
    });
    if (typeof w.updateKitUI === 'function') try { w.updateKitUI(); } catch (e) {}
  }

  function loadRates(code) {
    fetch('https://open.er-api.com/v6/latest/EUR')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.rates) return;
        Object.keys(RATES).forEach(function (k) {
          if (typeof d.rates[k] === 'number') RATES[k] = d.rates[k];
        });
        persist((w.INVELO_MARKET && w.INVELO_MARKET.country) || code);
      })
      .catch(function () {
        fetch('https://api.frankfurter.app/latest?from=EUR&to=USD,MXN,COP,CLP,PEN')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.rates) return;
            Object.keys(d.rates).forEach(function (k) { RATES[k] = d.rates[k]; });
            persist((w.INVELO_MARKET && w.INVELO_MARKET.country) || code);
          })
          .catch(function () {});
      });
  }

  function boot(code) {
    persist(code);
    loadRates(code);
  }

  function fetchTrace(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { return r.text(); }).then(parseTrace);
  }

  function pickCountry(votes) {
    var counts = {};
    votes.forEach(function (c) {
      if (!valid(c)) return;
      counts[c] = (counts[c] || 0) + 1;
    });
    var keys = Object.keys(counts);
    if (!keys.length) return '';
    keys.sort(function (a, b) { return counts[b] - counts[a]; });
    var latam = keys.filter(function (k) { return k !== 'PT'; });
    if (latam.length && counts[latam[0]] >= counts[keys[0]]) return latam[0];
    if (latam.length && counts['PT'] && counts[latam[0]] >= 1 && counts['PT'] <= counts[latam[0]]) return latam[0];
    if (latam.length && counts['PT'] && counts[latam[0]] >= 1) return latam[0];
    return keys[0];
  }

  function resolveGeo(done) {
    var q = param();
    if (valid(q)) { done(q); return; }

    var votes = [];
    var finished = false;
    function add(code) {
      code = String(code || '').toUpperCase();
      if (!valid(code) || finished) return;
      votes.push(code);
      if (code !== 'PT' && LATAM[code]) persist(code);
    }
    function finish(code) {
      if (finished) return;
      finished = true;
      done(valid(code) ? code : 'PT');
    }

    fetchTrace('https://one.one.one.one/cdn-cgi/trace').then(add).catch(function () {});
    fetchTrace('https://cloudflare.com/cdn-cgi/trace').then(add).catch(function () {});
    fetch('https://api.country.is/').then(function (r) { return r.json(); }).then(function (d) { add(d && d.country); }).catch(function () {});
    fetch('https://ipwho.is/').then(function (r) { return r.json(); }).then(function (d) { add(d && d.country_code); }).catch(function () {});
    fetch('https://ipapi.co/json/').then(function (r) { return r.json(); }).then(function (d) { add(d && d.country_code); }).catch(function () {});

    setTimeout(function () {
      var picked = pickCountry(votes);
      if (picked) { finish(picked); return; }
      var bl = fromLang();
      if (valid(bl) && bl !== 'ES') { finish(bl); return; }
      if (valid(bl)) { finish(bl); return; }
      finish('PT');
    }, 1400);
  }

  w.INVELO_MARKET = marketFor('PT');
  w.INVELO_I18N = {
    t: function (k) { return (I18N[(w.INVELO_MARKET && w.INVELO_MARKET.lang) || 'pt'] || I18N.pt || {})[k] || k; },
    formatMoney: formatMoney,
    shopPrices: function () { return SHOP_PRICES; },
    checkoutLocale: function () { return ''; },
    country: function () { return w.INVELO_MARKET.country; },
    currency: function () { return w.INVELO_MARKET.currency; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyI18n(w.INVELO_MARKET.lang); });
  } else applyI18n(w.INVELO_MARKET.lang);

  resolveGeo(boot);
})(window);
